module.exports = __webpack_public_path__ + "static/media/sd-fp.ea4a0fb0.png";